export const TODAY = 'TODAY';
export const ADVANCE = 'ADVANCE';
export const ALL = 'ALL';
export type OrderListTab = typeof TODAY | typeof ADVANCE | typeof ALL;
